<template>
  <div class="cash-audit">
    <div class="pictrue"><img src="@assets/images/examine.png" /></div>
    <div class="tip">{{$t('message.withdrawal.audit_tip')}}</div>
    <div class="time">{{ time }}</div>
    <div class="bnt bg-color-red" @click="$router.go(-1)">{{$t('message.withdrawal.audit_sure')}}</div>
  </div>
</template>
<script>
export default {
  name: "CashAudit",
  components: {},
  props: {},
  data: function() {
    return {
      time: ""
    };
  },
  mounted: function() {
    let myData = new Date();
    this.time = myData.toLocaleString();
  },
  methods: {}
};
</script>
